<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">CANNABIS</h1>
<h1 class="tp"><em>a history</em></h1>
<h2 class="author">MARTIN BOOTH</h2>
<p class="center"><span class="underline">Picador</span><br/>
A Thomas Dunne Book<br/>
St. Martin’s Press<br/>
New York</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?03995e8e